import React from 'react';
import { choose } from '../../utils/platform';
import { useChangePassword } from './useChangePassword';
import ChangePasswordDesktop from './ChangePassword.desktop';
import ChangePasswordMobile from './ChangePassword.mobile';
import '../../styles/people.css';

const ChangePasswordView = choose(ChangePasswordDesktop, ChangePasswordMobile);

export default function ChangePassword() {
  const vm = useChangePassword();
  return <ChangePasswordView vm={vm} />;
}
